
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/list-your-shares",
      function () {
        return require("private-next-pages/list-your-shares/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/list-your-shares"])
      });
    }
  